module.exports = __webpack_public_path__ + "static/media/Randolph-Creek-bylaws.942d49e2.pdf";